import { render, staticRenderFns } from "./subCommercialGradeListNew.vue?vue&type=template&id=50c4bd98&scoped=true"
import script from "./subCommercialGradeListNew.vue?vue&type=script&lang=js"
export * from "./subCommercialGradeListNew.vue?vue&type=script&lang=js"
import style0 from "./subCommercialGradeListNew.vue?vue&type=style&index=0&id=50c4bd98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c4bd98",
  null
  
)

export default component.exports